// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_parking_parkinglines_labels: MapboxStyleLayer[] = [
  {
    minzoom: 15,
    layout: {
      'text-allow-overlap': true,
      'text-ignore-placement': true,
      'text-size': ['interpolate', ['linear'], ['zoom'], 14.99, 0, 15, 9, 20, 20],
      'text-field': ['to-string', ['get', 'capacity']],
      'text-rotate': [
        'case',
        ['>', ['get', 'angle'], 90],
        ['-', ['get', 'angle'], 180],
        ['get', 'angle'],
      ],
      'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
    },
    type: 'symbol',
    id: 'parking labels',
    paint: {
      'text-color': [
        'match',
        ['get', 'operator_type'],
        ['private'],
        'rgba(61, 61, 61, 0.5)',
        'rgb(60, 60, 60)',
      ],
      'text-halo-width': ['interpolate', ['linear'], ['zoom'], 15, 1, 18, 2.5],
      'text-halo-color': 'rgb(255, 255, 255)',
      'icon-opacity': ['interpolate', ['linear'], ['zoom'], 0, 0, 14, 0, 15, 1],
    },
  },
]
